<template>
    <SideHeader :to="'/'" />
    <div style="padding-top: 55px;">
        <div class="section full">
            <div class="section-title pt-2">بارهای من</div>
            <Placeholder v-if="loading" />

            <div v-else>
                <div class="section" :class="{ 'mt-3 mb-3': index !== 0, 'mt-0 mb-3': index == 0 }"
                    v-for="(cargo, index) in cargos" :key="index.id">
                    <CardView :cargo="cargo" />
                </div>
                <p class="text-center" v-if="cargos == ''">باری یافت نشد</p>
            </div>

        </div>
    </div>
    <!-- <Footer v-show="isLoggedIn" /> -->

</template>
<script>
import Placeholder from "@/components/Placeholder.vue";
import axios from "axios";
import Swal from "sweetalert2";
import CardView from "@/views/myCargo/components/Cargo.vue";
// import Footer from "@/components/footer.vue";
import SideHeader from "@/components/SideHeader.vue";

export default {
    name: 'myCargo',
    components: {
        CardView,
        Placeholder,
        SideHeader,
        // Footer
    },
    data() {
        return {
            cargos: [],
            loading: false,
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        myCargos() {
            this.loading = true;
            axios
                .get(`https://core.iran-tarabar.ir/api/driver/requestDriverLoadsList`,this.axiosConfig)
                .then((response) => {
                    // console.log(response);
                    if (response.data.result == 1) {
                        this.cargos = response.data.loads;
                    }
                    this.loading = false;

                })
                .catch(() => {
                    // console.log(res);
                    // handle error
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "لطفا اینترنت خود را بررسی کنید",
                        showConfirmButton: true,
                        confirmButtonText: "تایید",
                        // timer: 2000
                    });
                    // loading.value = false;
                });
        }
    },
    computed: {
        isLoggedIn() {
            return window.localStorage.getItem("token");
        },
    },
    mounted() {
        this.myCargos();
    },
}
</script>
<style>
.pt-20 {
    padding-top: 2rem !important;
}
</style>